<template>
    <div>
        <b-form-group
            id="input-group-1"
            label="OTP"
            label-for="input-1"
            description=""
    >
        <b-form-input
                id="input-1"
                type="text"
                required
                placeholder="Enter OTP*"
                v-validate="'required|max:6|numeric|min:6'"
                name="OTP"
                v-model.trim="otp"
                :class="{ 'is-invalid': errors.has('OTP') }"
        ></b-form-input>
        <b-form-invalid-feedback id="input-1-live-feedback">
            <small>{{ errors.first("OTP") }}</small>
        </b-form-invalid-feedback>
    </b-form-group>
        <div class="d-flex justify-content-between">
            <b-button
                size="sm"
                pill
                variant="link"
                @click.prevent="resendOTP()"
                class="m-2 p-0"
            >
                <span>Resend</span>
            </b-button>
            <b-button
                size="md"
                pill
                variant="primary"
                @click.prevent="action()"
                class="m-2"
                style="padding: 0.5em 1.5em"
        >
            <span>Verify OTP</span>
        </b-button>

        </div>
    </div>
</template>

<script>
    import { authenticationApi } from "../../services/authenticationApi";

    export default {
        name: "otp-form",
        data() {
            return {
                otp: "",
            }
        },
        props:{
            phone_number: String
        },
        methods: {
            action() {
                this.$validator.validate("OTP").then(result => {
                    if (result) {
                        this.verifyOTP();
                    }
                });
            },
            resendOTP(){
                let otpdata = {
                    phone_number : this.phone_number,
                };
                authenticationApi.sendOTP(otpdata).then(res => {
                    console.log("otp send successfully",res)
                })
            },
            verifyOTP(){
                let otpdata = {
                    phone_number : this.phone_number,
                    otp:this.otp
                };
                authenticationApi.verifyOTP(otpdata).then( res => {
                   this.$emit('signUp')
                })
            }
        }
    }
</script>

<style scoped>

</style>
